import { Box, Button, Typography } from "@mui/material";
import { FlexCenterWrapper } from "../components/DefaultNoDataWrapper";
import { useNavigate } from "react-router-dom";

const DefaultRoutePage = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        minHeight: "100vh",
      }}
    >
      <Box bgcolor={"primary.main"} p={2} width={"70vw"} height={"80vh"}>
        <FlexCenterWrapper>
          <Typography variant="h1" style={{ color: "white" }}>
            404
          </Typography>
          <Typography variant="h6" style={{ color: "white" }} mb={1}>
            The page you’re looking for doesn’t exist.{" "}
            {/* todo: need to change email to support email */}
            <a href="rajkumar.rathod@medarch.com" style={{ color: "white" }}>
              contact support
            </a>
          </Typography>
          <Button variant="contained" onClick={() => navigate(-1)}>
            Back Home
          </Button>
        </FlexCenterWrapper>
      </Box>
    </Box>
  );
};

export default DefaultRoutePage;
